"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSVGIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
function withSVGIcon(Icon, extraProps) {
    if (extraProps === void 0) { extraProps = { viewBox: '0 0 32 32' }; }
    return function SVGIconWrapper(props) {
        var _a = props.size, size = _a === void 0 ? 32 : _a, boxProps = props.boxProps, _b = props.strokeWidth, strokeWidth = _b === void 0 ? null : _b, rest = __rest(props, ["size", "boxProps", "strokeWidth"]);
        var strokeWidthToUse = strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : (size >= 32 ? 1.5 : 1);
        return (jsx_runtime_1.jsx(core_1.Box, __assign({ component: "svg", width: size, height: size }, boxProps, extraProps, { fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx_runtime_1.jsx(Icon, __assign({}, rest, { strokeWidth: strokeWidthToUse }), void 0) }), void 0));
    };
}
exports.withSVGIcon = withSVGIcon;
//# sourceMappingURL=withSVGIcon.js.map